import { render } from "./CartDetailsComponent.vue?vue&type=template&id=3780276e&scoped=true"
import script from "./CartDetailsComponent.vue?vue&type=script&lang=js"
export * from "./CartDetailsComponent.vue?vue&type=script&lang=js"

import "./CartDetailsComponent.vue?vue&type=style&index=0&id=3780276e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3780276e"]])

export default __exports__